// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media screen and (max-width:979px){.scrollbar-ctn[data-v-2b92f7a2]{padding-left:20px;padding-right:20px}}", ""]);
// Exports
module.exports = exports;
